import React from 'react';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/material';
import { FormInput } from 'components/molecules/FormInput';
import { FormDatePicker } from 'components/molecules/FormDatePicker';

interface IAddOffenceListItem {
  index: number;
  arrayName?: string;
  control: any;
  errors: any;
}

const AddOffenceListItem = ({ index, arrayName, control, errors }: IAddOffenceListItem) => (
  <Box>
    <Grid container spacing={1}>
      <Grid item xs={4}>
        <FormDatePicker
          name={`${arrayName}[${index}].offenceDate`}
          label="Date*"
          fieldName="offenceDate"
          arrayName={arrayName}
          arrayIndex={index}
          control={control}
          errors={errors}
        />
      </Grid>
      <Grid item xs={4}>
        <FormInput
          name={`${arrayName}[${index}].offenceName`}
          label="Offence"
          fieldName="offenceName"
          arrayName={arrayName}
          arrayIndex={index}
          control={control}
          errors={errors}
        />
      </Grid>
    </Grid>
  </Box>
);

export default AddOffenceListItem;
